import React from 'react'
import { IoFootballOutline } from 'react-icons/io5'
import { Widget } from '../Widget'
import { useLeague, TOP_LEAGUES, type League } from '../../../context/LeagueContext'
import { getLeagueBadge, getLeagueLogo } from '../../../utils/leagueBadge'
import type { PageId } from '../../BottomNav'

interface TopLeaguesWidgetProps {
  isEditing?: boolean
  onRemove?: () => void
  onNavigate?: (page: PageId) => void
  onLeagueClick?: (apiLeagueId: number) => void
}

export function TopLeaguesWidget({
  isEditing,
  onRemove,
  onNavigate,
  onLeagueClick,
}: TopLeaguesWidgetProps) {
  const { setLeague } = useLeague()

  const handleLeagueClick = (league: League) => {
    setLeague(league)
    // Navigate to league page if handler provided, otherwise fall back to fixtures
    if (onLeagueClick) {
      onLeagueClick(league.api_league_id)
    } else {
      onNavigate?.('fixtures')
    }
  }

  return (
    <Widget
      id="leagues"
      title="Top Leagues"
      icon={<IoFootballOutline size={18} />}
      isEditing={isEditing}
      onRemove={onRemove}
      onNavigate={onNavigate}
    >
      <div className="widget-leagues">
        <div className="widget-leagues-grid">
          {TOP_LEAGUES.map((league) => {
            const badge = getLeagueBadge(league.name)
            const logo = getLeagueLogo(league.name)

            return (
              <button
                key={league.id}
                className="widget-league-item"
                onClick={() => handleLeagueClick(league)}
                title={league.name}
              >
                {logo ? (
                  <img
                    src={logo}
                    alt={league.name}
                    className="widget-league-logo"
                    onError={(e) => {
                      // Hide broken images
                      e.currentTarget.style.display = 'none'
                    }}
                  />
                ) : (
                  <span
                    className="widget-league-badge"
                    style={{ backgroundColor: badge.color }}
                  >
                    {badge.code}
                  </span>
                )}
                <span className="widget-league-name">{league.shortName}</span>
              </button>
            )
          })}
        </div>
      </div>
    </Widget>
  )
}
